export const Main = styled.main`
  width: 100%;
  height: auto;
  background-color: rgb(242, 242, 242);

  @media (min-width: 1025px) {
    width: 100%
  }
`;
